/**
 * Endereços das fotos das pessoas: a do perfil e a de cada mesa (o "avatar do personagem" do
 * original). Levam a versão (`?v=`), que muda a cada troca, então ficam em cache. Ficam no
 * endereço do servidor (src/serverUrl.ts).
 */
import { serverUrl } from '../serverUrl.js';

/**
 * O nome da pessoa vai junto quando a foto dela é arrastada (para a cena virar um token com esse
 * nome). Sem ele, o navegador dá à imagem o nome do fim da URL, que é o id da pessoa.
 */
export const AVATAR_DRAG_NAME = 'application/x-rpgdesk-avatar-name';

export function avatarUrl(userId: string, version: number): string {
  return serverUrl(`/api/avatars/${encodeURIComponent(userId)}?v=${version}`);
}

export function roomAvatarUrl(roomId: string, userId: string, version: number): string {
  return serverUrl(`/api/rooms/${encodeURIComponent(roomId)}/avatars/${encodeURIComponent(userId)}?v=${version}`);
}

/**
 * A foto que aparece: a da mesa (versão > 0), senão a do perfil, senão nenhuma (fica a inicial),
 * como o `VerificarQualAvatarExibir` do original.
 */
export function avatarSrc(userId: string | undefined, avatarVersion: number, room?: { id: string; avatarVersion: number }): string | null {
  if (!userId) return null;
  if (room && room.avatarVersion > 0) return roomAvatarUrl(room.id, userId, room.avatarVersion);
  return avatarVersion > 0 ? avatarUrl(userId, avatarVersion) : null;
}
